import { addressFormat } from './address-format';

export const AU = {
  validator: null,
  addressFormat,
};
